import appStore from 'redux/stores/app.store';
import amplitude from 'tools/amplitude/amplitude';

import {
  LogCIMChatReasonParams,
  LogEventCIMChatReason,
} from './clientInfoMod.analytic.model';

export function logAnalyticCIMChatReason(params: LogCIMChatReasonParams) {
  const { orderDetail, reason } = params;
  const data: LogEventCIMChatReason = {
    PARTNER_ID: appStore.getPartnerId(),
    STORE_ID: orderDetail.products[0].storeId,
    ORDER_ID: orderDetail.id,
    CHAT_MOTIVE: reason,
  };
  amplitude.logEvent('CHAT_WITH_USER', data);
}

export const clientInfoModuleAnalytics = {
  logChatReason: logAnalyticCIMChatReason,
} as const;
